import { Route, Routes } from 'react-router-dom'

import { ReservationProvider } from '@/components/ReservationContext'
import { LoginPage } from '@/pages/login/LoginPage'
import HotelManagementPage from '@/pages/panel-interno/HotelManagementPage'
import BillingPage from '@/pages/panel-interno/facturacion/BillingPage'
import PanelInternoLayout from '@/pages/panel-interno/layout'
import MobilePanelInterno from '@/pages/panel-interno/mobile/page'
import PlanningPage from '@/pages/panel-interno/planning-page/PlanningPage'
import SetupPage from '@/pages/panel-interno/setup/page'
import EmployeeSelection from '@/pages/panel-interno/tienda/employee-selection'
import StorePage from '@/pages/panel-interno/tienda/store'
import { useIsMobile } from '@/shared/lib/hooks/useIsMobile'

import BookingConfirmationPage from '../../pages/BookingConfirmationPage'
import BookingPage from '../../pages/BookingPage'
import HairSalonBookingPage from '../../pages/HairSalonBookingPage'
import Home from '../../pages/HomePage'
import ClientDetailsPage from '../../pages/client-page/ClientPage'
import ClientsPage from '../../pages/clients-page/ClientsPage'
import PerfilClientesPage from '../../pages/external-client-page/ExternalClientPage'
import PeluqueriaPage from '../../pages/panel-interno/HairSalonInternalPanelPage'
import { ProtectedStaffPage } from './ProtectedPage'
import { WithAuthRequired } from './WithAuthRequired'
import { WithSecretAuth } from './WithSecretAuth'

export const RoutingComponent = () => {
    const isMobile = useIsMobile()

    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route
                path='/booking'
                element={
                    <WithAuthRequired>
                        <ReservationProvider>
                            <BookingPage />
                        </ReservationProvider>
                    </WithAuthRequired>
                }
            />
            <Route
                path='/booking/confirmation/:reservationId'
                element={
                    <WithAuthRequired>
                        <ReservationProvider>
                            <BookingConfirmationPage />
                        </ReservationProvider>
                    </WithAuthRequired>
                }
            />
            <Route path='/login' element={<LoginPage />} />
            <Route
                path='/peluqueria-booking'
                element={
                    <WithAuthRequired>
                        <ReservationProvider>
                            <HairSalonBookingPage />
                        </ReservationProvider>
                    </WithAuthRequired>
                }
            />
            <Route
                path='/perfil'
                element={
                    <WithSecretAuth>
                        <ReservationProvider>
                            <PerfilClientesPage />
                        </ReservationProvider>
                    </WithSecretAuth>
                }
            />
            <Route
                path='/panel-interno/*'
                element={
                    <ProtectedStaffPage>
                        <ReservationProvider>
                            {isMobile ? (
                                <MobilePanelInterno />
                            ) : (
                                <PanelInternoLayout>
                                    <Routes>
                                        <Route index element={<HotelManagementPage />} />
                                        <Route path='peluqueria' element={<PeluqueriaPage />} />
                                        <Route path='tienda' element={<EmployeeSelection />} />
                                        <Route path='tienda/store' element={<StorePage />} />
                                        <Route path='planning' element={<PlanningPage />} />
                                        <Route path='clientes' element={<ClientsPage />} />
                                        <Route path='clientes/:id' element={<ClientDetailsPage />} />
                                        <Route path='setup' element={<SetupPage />} />
                                        <Route path='facturacion' element={<BillingPage />} />
                                    </Routes>
                                </PanelInternoLayout>
                            )}
                        </ReservationProvider>
                    </ProtectedStaffPage>
                }
            />
            <Route path='*' element={<div>404 - Page not found</div>} />
        </Routes>
    )
}
